import { template as template_890d6cf4c1d2480fa1e9ad0c847cbb57 } from "@ember/template-compiler";
import PracticeWebsiteNav from 'client-portal/components/practice-website/nav';
import styles from './desktop-menu.module.scss';
export default template_890d6cf4c1d2480fa1e9ad0c847cbb57(`
  <div class={{styles.component}} ...attributes inert={{if @inertMenu "true"}}>
    <PracticeWebsiteNav
      class="nav"
      @model={{@model}}
      @showSectionSpecialties={{@showSectionSpecialties}}
      @showSectionTestimonials={{@showSectionTestimonials}}
      @showSectionLocations={{@showSectionLocations}}
      @locationsSectionTitle={{@locationsSectionTitle}}
    />
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
